import { render, staticRenderFns } from "./CreateProductGroup.vue?vue&type=template&id=c2c45e72&scoped=true&"
import script from "./CreateProductGroup.vue?vue&type=script&lang=js&"
export * from "./CreateProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductGroup.vue?vue&type=style&index=0&id=c2c45e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c45e72",
  null
  
)

export default component.exports